import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Button, CircularProgress, Container } from '@mui/material';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';


const RewindPage = () => {
  const { id } = useParams();
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [imageError, setImageError] = useState(false);

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isMac = /Mac/i.test(navigator.userAgent) || /Mac/i.test(navigator.platform);
  const isVisionPro = !isIOS && /visionOS|xrOS|Vision/i.test(navigator.userAgent);

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const response = await axios.get(`/api/EventRecording/getRecordingMetadata?recordingId=${id}`);
        setEventData(response.data);
      } catch (err) {
        console.error('Error fetching rewind data:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchEvent();
  }, [id]);

  const handleJoin = () => {
    window.location.href = "https://apps.apple.com/app/6754709124";
  };

  return (
    <Box
      sx={{
        backgroundColor: '#000000',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        color: '#fff',
        fontFamily: 'Unbounded, sans-serif'
      }}
    >
      <Header />

      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', py: 8 }}>
        {loading ? (
          <CircularProgress sx={{ color: '#30D158' }} />
        ) : error || !eventData ? (
          <Typography variant="h5" color="error" fontFamily="Unbounded, sans-serif">
            Rewind not found
          </Typography>
        ) : (
          <Container maxWidth="sm" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {/* Banner Image */}
            {eventData.imageUrl && !imageError && (
              <Box
                component="img"
                src={eventData.imageUrl}
                alt="Rewind Banner"
                onError={() => setImageError(true)}
                sx={{
                  width: '100%',
                  borderRadius: 4,
                  boxShadow: '0 10px 40px rgba(0, 0, 0, 0.6)',
                  mb: 4,
                  border: '1px solid rgba(255, 255, 255, 0.1)'
                }}
              />
            )}

            {/* Rewind Title */}
            <Typography
              variant="h5"
              sx={{
                color: '#30D158',
                fontFamily: 'Unbounded, sans-serif',
                fontWeight: 600,
                mb: 3,
                textAlign: 'center'
              }}
            >
              {eventData.title || eventData.Title || eventData.name || 'Rewind'}
            </Typography>

            {/* Description */}
            {eventData.description && (
              <Typography
                variant="body1"
                sx={{
                  mb: 5,
                  color: 'rgba(255,255,255,0.8)',
                  whiteSpace: 'pre-line',
                  textAlign: 'center',
                  fontSize: '1.1rem',
                  lineHeight: 1.6,
                  fontFamily: 'Unbounded, sans-serif'
                }}
              >
                {eventData.description}
              </Typography>
            )}

            {/* Disclaimer for non-Vision Pro users */}
            {!isVisionPro && (
              <Typography
                variant="body2"
                sx={{
                  mb: 2,
                  color: 'rgba(255,255,255,0.6)',
                  textAlign: 'center',
                  fontSize: '0.9rem',
                  fontFamily: 'Unbounded, sans-serif'
                }}
              >
                In order to view the rewind you will have to open the link on your Vision Pro
              </Typography>
            )}

            {/* Watch Button */}
            <Button
              variant="contained"
              onClick={handleJoin}
              fullWidth
              sx={{
                backgroundColor: '#30D158',
                color: '#FFFFFF',
                fontWeight: '700',
                py: 2,
                borderRadius: '50px',
                textTransform: 'none',
                fontSize: '1.2rem',
                fontFamily: 'Unbounded, sans-serif',
                transition: 'transform 0.3s ease, background-color 0.3s ease',
                boxShadow: '0 8px 24px rgba(48, 209, 88, 0.3)',
                '&:hover': {
                  backgroundColor: '#30D158',
                  boxShadow: '0 12px 32px rgba(48, 209, 88, 0.5)',
                  transform: 'scale(1.03)',
                }
              }}
            >
              Watch Rewind
            </Button>
          </Container>
        )}
      </Box>

      <Footer />
    </Box>
  );
};

export default RewindPage;
